import React from 'react';
import useChangePreferredLocale from '../useChangePreferredLocale';
export default function useEffectPreferredLocale(locale) {
  var handleChangeLocale = useChangePreferredLocale();
  React.useEffect(function () {
    handleChangeLocale(locale);
  }, [handleChangeLocale, locale]);
}